import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { catchError, interval, of, takeUntil } from 'rxjs';

import { ChangeDetectorRef, Component, NgZone, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, FormControl, Validators, FormArray, AbstractControl, ValidationErrors } from "@angular/forms";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ApiService } from "../../../../../shared/services/api.service";
import { AutofilliaService } from "../../../../../shared/services/autofillia.service";
import { RegisterIAService } from "../../../../../shared/services/register-ia.service";
import { Subject, switchMap, timer } from 'rxjs';
import { CaptchaService } from '../../../../../shared/services/captcha.service';
import { CommonService } from '../../../../../shared/services/common.service';
import { TrimInputValueDirective } from '../../../../../shared/directive/trim-input-value.directive';
//import { directive } from '../../../../../shared/directive/trim-input-value.directive';



@Component({
  selector: 'app-iaregister',
  templateUrl: './iaregister.component.html',
  styleUrl: './iaregister.component.css'
})
export class IAregisterComponent implements OnInit {

  // Timer variables
  emailOtpTimer: number = 300; // 300 seconds for email OTP timer
  mobileOtpTimer: number = 300; // 300 seconds for mobile OTP timer
  mobileSpocOtpTimer: number = 300; 
  emailOtpTimerRunning: boolean = false;
  mobileOtpTimerRunning: boolean = false;
  mobileSpocOtpTimerRunning: boolean = false;
  countdown: number = 300; // 300-second countdown for resend OTP
  countdownDisplay: string | undefined;
  isResendButtonDisabled: boolean = true;
  isEmailResendButtonDisabled: boolean = true;
  isMobResendButtonDisabled: boolean = true;

  countdownSubject: Subject<void> = new Subject<void>();

  mobileResendCount = 1;
  emailResendCount = 1;

  mobileOtpInterval: any = null; // Store the interval reference
  emailOtpInterval: any = null; // Store the interval reference

  spocmobileTimer: any = null; // Store the interval reference

  originalData: any;

  isButtonDisabled: boolean = false;
  isButtonEmailDisabled: boolean = false;
  isButtonMobileDisabled: boolean = false;
  isButtonSpocMobileDisabled: boolean = false;
  isVerifyButtonDisabled: boolean = false;

  emailOtpSent: boolean = false;       // True if email OTP is sent, false otherwise
  mobileOtpSent: boolean = false;      // True if mobile OTP is sent, false otherwise
  resendEmailOtpDisabled: boolean = true;
  resendMobileOtpDisabled: boolean = true;
  resendSpocMobileOtpDisabled: boolean = true;



  isVerifyEmailOtpButtonDisabled: boolean = true;// Flag for Verify Email OTP button
  isVerifyMobileOtpButtonDisabled: boolean = true;
  isVerifySpocMobileOtpButtonDisabled: boolean = true;
  isOTPVerified: boolean = true;
  isEmailOTPVerified: boolean = true;
  isMobOTPVerified: boolean = true;

  isSpocOTPVerified: boolean = false; // Initially false

  data: any[];
  filteredData: any;

  focusSector: any[] = [];
  selectedFocusSector: string[] = [];
  selectedFocusSectorName: string[] = [];
  formData: any;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;

  resendCount: number = 0;
  maxResendAttempts: number = 5;
  otpError: boolean = false;
  otpSuccess: boolean = false;
  emailotpError: boolean = false;
  emailotpSuccess: boolean = false;

  captcha!: string;
  captchaError: boolean = false;
  captchaSuccess: boolean = false;
  isPreviewDisabled: boolean = true;

  isEditable: boolean = false;
  interests: any[] = [];
  interventions: any[] = [];
  filteredInterests: any[] = [];
  editingIndex: number | null = null;

  selectedPairs: {
    interventionId: any;
    interventionName: string,
    interestId: string,
    interestName: string
  }[] = [];
  selectedSpoc: {
    SpocName: any;
    SpocDesignation: string,
    SpocEmail: string,
    SpocMobile: string
  }[] = [];
  spocList: any[] = []; // Array to store records
  txtResetCancel: string = 'Reset';
  holdEditData: any;

  constructor(private router: Router, private ia_serv: AutofilliaService, private fb: FormBuilder, private ia_service: RegisterIAService, private apiService: ApiService, private toastr: ToastrService, private captchaService: CaptchaService, private ngZone: NgZone,
    private common: CommonService,
    private cdr: ChangeDetectorRef) {
    this.data = [];
    this.form.controls['Intervention'].setValue(null);
    this.form.controls['InterestsId'].setValue(null);
  }
  form = new FormGroup({
    //orgname: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.common.stringWithSpacePattern)]),
    NameOfOrganisation: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.common.nameOfOrganisation)]),
    ShortNameOfOrganisation: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(10), Validators.pattern('^[a-zA-Z]+$')]),
    Email: new FormControl('', [Validators.required, Validators.maxLength(100), Validators.pattern(this.common.emailPattern)]),
    Password: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(20), Validators.pattern(this.common.passwordPattern)]),
    confpassword: new FormControl('', [
      Validators.required,
      Validators.minLength(8),
      Validators.maxLength(20),
      Validators.pattern(this.common.passwordPattern)],), // Move passwordMatchValidator here
    MobileNumber: new FormControl('', [Validators.required, Validators.maxLength(10), Validators.pattern(this.common.mobilePattern)]),
    /*emailid: new FormControl('', [Validators.required, Validators.minLength(3)]),*/
    mobotp: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern('^[0-9]+$')]),
    spocmobotp: new FormControl('', [ Validators.minLength(6), Validators.maxLength(6), Validators.pattern('^[0-9]+$')]),
    emailotp: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern('^[0-9]+$')]),
    /*emailotp: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern('[0-9]{6}')]),*/
    ContactNumber: new FormControl('', [Validators.maxLength(13), Validators.pattern(this.common.phonePattern)]),
    /*focussector: new FormControl('', [Validators.required, Validators.minLength(3)]),*/
    //district: new FormControl('', [Validators.required, Validators.minLength(6)]),
    //dic: new FormControl('', [Validators.required, Validators.minLength(6)]),
    AddressOfOrganisation: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(300), Validators.pattern(this.common.addressPattern)]),
    IAUserName: new FormControl(''),
    focusSectorId: new FormControl(''),
    focusSectorName: new FormControl(''),
    //captcha: new FormControl('', [Validators.required,]),
    //termsConditionAccepted: new FormControl('', [Validators.required]),
    //thirdPartyUndertaking: new FormControl('', [Validators.required]),
    Intervention: new FormControl(''),
    InterestsId: new FormControl(''),
    SpocName: new FormControl('', [ Validators.minLength(3), Validators.maxLength(50), Validators.pattern('^[a-zA-Z ]+$')]),
    SpocDesignation: new FormControl( '',[Validators.minLength(3), Validators.maxLength(50)]),
    SpocEmail: new FormControl('', [ Validators.maxLength(100), Validators.pattern(this.common.emailPattern)]),
    SpocMobile: new FormControl('', [Validators.maxLength(10), Validators.pattern(this.common.mobilePattern)]),
    //InterestName: new FormControl(''),
    //InterventionName: new FormControl(''),
    //focusSectorid: new FormArray([]),
    //focusSectorName: new FormArray([]),
    /*intervention: new FormControl('', [Validators.required, Validators.minLength(10)]),*/
    //bankname: new FormControl('', [Validators.required, Validators.minLength(3), Validators.pattern('^[a-zA-Z \-\']+')]),
    //accnum: new FormControl('', [Validators.required, Validators.minLength(10),]),
    //ifsccode: new FormControl('', [Validators.required, Validators.minLength(8)]),
    //cin: new FormControl('', [Validators.required, Validators.minLength(3)]),
    //orgpan: new FormControl('', [Validators.required, Validators.minLength(10)]),
    /*regdate: new FormControl('', [Validators.required]),*/
  }
    , {
      validators: this.passwordMatchValidator // Use it here as a form-level validator
    }
  );

  async ngOnInit(): Promise<void> {

    //// Retrieve form data from navigation state
    //if (this.router.getCurrentNavigation()?.extras.state) {
    //  this.formData = this.router.getCurrentNavigation()?.extras.state?.['formData'] || {};
    //}

     this.loadInterventions();
    this.loadInterests();
     await this.LoadFocusSector();
   // this.generateCaptcha();
    

    

    this.form.statusChanges.subscribe(() => {
      this.isVerifyButtonDisabled = !this.form.valid;
      if (this.form.valid && this.spocList.length >= 1) {
        this.isPreviewDisabled = false;
      }
      else {
        this.isPreviewDisabled = true;
      }
      //this.cdr.detectChanges();
      //  this.cdr.markForCheck(); // or this.cdr.detectChanges();
    });


    const incomingFormData = history.state.formData;
    if (incomingFormData) {
      this.form.patchValue({
        NameOfOrganisation: incomingFormData.NameOfOrganisation,
        ShortNameOfOrganisation: incomingFormData.ShortNameOfOrganisation,
        Email: incomingFormData.Email,
        //Password: incomingFormData.Password,
        MobileNumber: incomingFormData.MobileNumber,
        ContactNumber: incomingFormData.ContactNumber,
        AddressOfOrganisation: incomingFormData.AddressOfOrganisation,
        IAUserName: incomingFormData.IAUserName,
        focusSectorId: incomingFormData.focusSectorId,
        focusSectorName: incomingFormData.focusSectorName,
        Intervention: incomingFormData.Intervention,
        InterestsId: incomingFormData.InterestsId,
        SpocName: incomingFormData.SpocName,
        SpocDesignation: incomingFormData.SpocDesignation,
        SpocEmail: incomingFormData.SpocEmail,
        SpocMobile: incomingFormData.SpocMobile,
        
      });


    }

  }

 
  startEmailOtpTimer() {
    if (this.emailOtpTimerRunning) return; // Prevent multiple timers

    this.emailOtpTimerRunning = true;
    this.emailOtpTimer = 300;
    this.resendEmailOtpDisabled = true; // Disable resend while timer is running

    this.emailOtpInterval = setInterval(() => {
      if (this.emailOtpTimer > 0) {
        this.emailOtpTimer--;
      } else {
        this.stopEmailCountdown(); // Stop timer when it reaches 0
      }
    }, 1000);
  }


  goToStep2() {
    //const step2Element = document.getElementById('Step2');
    //if (step2Element) {
    //  step2Element.classList.add('active', 'show'); // Add Bootstrap classes for tab activation
    //  step2Element.classList.remove('fade');       // Remove fade if required
    //}
    
    if (this.form.controls.NameOfOrganisation.valid &&
      this.form.controls.ShortNameOfOrganisation.valid &&
      this.form.controls.AddressOfOrganisation.valid &&
      this.form.controls.Email.valid &&
      this.form.controls.Password.valid &&
      this.form.controls.confpassword.valid &&
      this.form.controls.MobileNumber.valid &&
      this.form.controls.IAUserName.valid &&
      this.otpSuccess == true &&
      this.emailotpSuccess == true) { 

      const step2Tab = document.getElementById('Step2-tab');
      const step2Content = document.getElementById('Step2');

      if (step2Tab && step2Content) {
        // Deactivate Step1
        const step1Tab = document.getElementById('Step1-tab');
        const step1Content = document.getElementById('Step1');

        if (step1Tab && step1Content) {
          step1Tab.classList.remove('active');
          step1Content.classList.remove('active', 'show');
        }

        // Activate Step2
        step2Tab.classList.add('active');
        step2Content.classList.add('active', 'show');
      }
     

    }
    else {
      //this.form.controls.NameOfOrganisation.markAsTouched();
      //this.form.controls.ShortNameOfOrganisation.markAsTouched();
      //this.form.controls.AddressOfOrganisation.markAsTouched();
      //this.form.controls.Email.markAsTouched();
      this.form.markAllAsTouched();
    }
  }

  
  startMobileOtpTimer() {
    if (this.mobileOtpTimerRunning) return; // Prevent multiple timers

    this.mobileOtpTimerRunning = true;
    this.mobileOtpTimer = 300;
    this.resendMobileOtpDisabled = true;

    this.mobileOtpInterval = setInterval(() => {
      if (this.mobileOtpTimer > 0) {
        this.mobileOtpTimer--;
      } else {
        this.stopMobCountdown(); // Stop timer when it reaches 0
      }
    }, 1000);
  }

 

  startSpocMobileOtpTimer() {
    this.mobileSpocOtpTimerRunning = true;
    this.mobileSpocOtpTimer = 300;
    this.resendSpocMobileOtpDisabled = true;

    const spocmobileTimer = setInterval(() => {
      if (this.mobileSpocOtpTimer > 0) {
        this.mobileSpocOtpTimer--;
      } else {
        //clearInterval(spocmobileTimer);
        //this.ngZone.run(() => {  // Ensures UI updates
        //  this.mobileSpocOtpTimerRunning = false;
        //  this.resendSpocMobileOtpDisabled = false;
        //});
        this.stopSpocMobCountdown();
      }
    }, 1000);
  }
  

  // Start countdown for Resend OTP (300 seconds)
  startResendCountdown() {
    this.isResendButtonDisabled = true;
    this.countdown = 300; // 300-second countdown
    interval(1000).pipe(takeUntil(this.countdownSubject)).subscribe(() => {
      if (this.countdown > 0) {
        this.countdown--;
        this.updateCountdownDisplay();
      } else {
        this.stopCountdown();
      }
    });
  }

  // Update countdown display
  updateCountdownDisplay() {
    const minutes = Math.floor(this.countdown / 60);
    const seconds = this.countdown % 60;
    this.countdownDisplay = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }

  // Stop the countdown
  stopCountdown() {
    this.countdownSubject.next();
    this.isResendButtonDisabled = false;
    this.countdownDisplay = '';
  }
  //stopEmailCountdown() {
  //  this.countdownSubject.next();
  //  this.isEmailResendButtonDisabled = false;
  //  this.countdownDisplay = '';
  //}
  //stopMobCountdown() {
  //  this.countdownSubject.next();
  //  this.isMobResendButtonDisabled = false;
  //  this.countdownDisplay = '';
  //}

  stopMobCountdown() {
    clearInterval(this.mobileOtpInterval);
    this.mobileOtpInterval = null; // Reset timer reference
    this.mobileOtpTimerRunning = false;
    this.mobileOtpTimer = 0;
    this.resendMobileOtpDisabled = false; // Enable resend button after timer stops
  }

  stopEmailCountdown() {
    clearInterval(this.emailOtpInterval);
    this.emailOtpInterval = null; // Reset timer reference
    this.emailOtpTimerRunning = false;
    this.emailOtpTimer = 0;
    this.resendEmailOtpDisabled = false; // Enable resend after timer stops
  }

  stopSpocMobCountdown() {
    clearInterval(this.spocmobileTimer);
    this.spocmobileTimer = null;
      this.mobileSpocOtpTimerRunning = false;
      this.resendSpocMobileOtpDisabled = false;
    
  }
  

  // Reset the countdown when needed (e.g., after OTP resend)
  resetCountdown() {
    this.stopCountdown();
    this.startResendCountdown();
  }

  // Clean up timers when component is destroyed
  ngOnDestroy() {
    this.countdownSubject.next();
    this.countdownSubject.complete();
  }

 
  get f() {
    return this.form.controls;
  }

  //passwordMatchValidator(group: AbstractControl): { [key: string]: boolean } | null {
  //  const password = group.get('Password')?.value;
  //  const confirmPassword = group.get('confpassword')?.value;

  //  return password && confirmPassword && password !== confirmPassword
  //    ? { passwordMismatch: true }
  //    : null;
  //}
  //passwordMatchValidator(group: AbstractControl): { [key: string]: boolean } | null {
  //  const password = group.get('Password')?.value;
  //  const confirmPassword = group.get('confpassword')?.value;

  //  if (password && confirmPassword && password !== confirmPassword) {
  //    return { passwordMismatch: true }; // Return error if they do not match
  //  }
  //  return null; // No error
  //}
  passwordMatchValidator(group: AbstractControl): { [key: string]: boolean } | null {
    const password = group.get('Password')?.value;
    const confirmPassword = group.get('confpassword')?.value;
    const confPasswordControl = group.get('confpassword'); // Get the confpassword control

    if (password && confirmPassword && password !== confirmPassword) {
      confPasswordControl?.setErrors({ ...confPasswordControl.errors, passwordMismatch: true }); // Set error
      return { passwordMismatch: true };
    }

    // Remove the passwordMismatch error if passwords match
    if (confPasswordControl?.errors) {
      const { passwordMismatch, ...otherErrors } = confPasswordControl.errors;
      if (Object.keys(otherErrors).length > 0) {
        confPasswordControl.setErrors(otherErrors); // Retain other errors
      } else {
        confPasswordControl.setErrors(null); // No errors left
      }
    }

    return null; // No error
  }



  get emailControlValue(): string | null {
    // var s  = this.form.get('email')?.value;

    this.form.get('IAUserName')?.setValue(this.form.get('Email')?.value ?? null);
    //.log(this.form);
    return this.form.get('Email')?.value ?? null;

  }
  //numberOnly(event: any): boolean {
  //  const charCode = (event.which) ? event.which : event.keyCode;
  //  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
  //    return false;
  //  }
  //  return true;
  //}

  //formatContactNumber(event: any): void {
  //  let input = event.target.value.replace(/\D/g, ''); // Remove non-numeric characters
  //  if (input.length > 3 && input.length <= 6) {
  //    input = input.replace(/^(\d{3})(\d+)/, '$1-$2'); // Format as XXX-XXX
  //  } else if (input.length > 6) {
  //    input = input.replace(/^(\d{3})(\d{3})(\d+)/, '$1-$2-$3'); // Format as XXX-XXX-XXXX
  //  }
  //  event.target.value = input; // Update the input field value
  //}

  formatContactNumber(event: any): void {
    let input = event.target.value.replace(/\D/g, ''); // Remove non-numeric characters

    if (input.length > 3 && input.length <= 7) {
      input = input.replace(/^(\d{3})(\d+)/, '$1-$2'); // Format as XXX-XXXX
    } else if (input.length > 7) {
      input = input.replace(/^(\d{3})(\d{4})(\d+)/, '$1-$2-$3'); // Format as XXX-XXXX-XXXX
    }
    

    event.target.value = input.substring(0, 13); // Limit to 13 characters (XXX-XXXX-XXXX)
  }

  numberOnly(event: KeyboardEvent): void {
    const charCode = event.keyCode || event.which;
    if (charCode < 48 || charCode > 57) {
      // Allow only numbers
      event.preventDefault();
    }
  }


  numberanddashOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 45) {
      return false;
    }
    return true;
  }
  textOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122)) {
      return false;
    }
    return true;
  }
  //textAndSpaceOnly(event: any): boolean {
  //  const charCode = (event.which) ? event.which : event.keyCode;

  //  // Allow letters (A-Z, a-z) and space (charCode === 32)
  //  if (
  //    charCode > 31 &&
  //    (charCode < 65 || charCode > 90) && // Not uppercase letters
  //    (charCode < 97 || charCode > 122) && // Not lowercase letters
  //    charCode !== 32 // Not a space
  //  ) {
  //    return false;
  //  }
  //  return true;
  //}

  textAndSpaceOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    const target = event.target as HTMLInputElement;
    const currentValue = target.value;

    // Allow letters (A-Z, a-z) and a single space (not after another space)
    if ((charCode >= 65 && charCode <= 90) || // Uppercase letters
      (charCode >= 97 && charCode <= 122) || // Lowercase letters
      (charCode === 32 && !currentValue.endsWith(' '))) { // Space and not after another space
      return true;
    }

    // Block all other characters
    return false;
  }

  //textAndSpaceAndDotOnly(event: any): boolean {
  //  const charCode = event.which ? event.which : event.keyCode;

  //  // Allow letters (A-Z, a-z) and space (ASCII 32)
  //  if ((charCode >= 65 && charCode <= 90) || // Uppercase letters
  //    (charCode >= 97 && charCode <= 122) || // Lowercase letters
  //    charCode === 32 ||
  //    charCode === 46) {
  //    return true;
  //  }

  //  // Block all other characters
  //  return false;
  //}

  textAndSpaceAndDotOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    const char = String.fromCharCode(charCode);
    const target = event.target as HTMLInputElement; // Get the input element
    const currentValue = target.value;

    // Allow letters (A-Z, a-z), single space, and dot (.)
    if ((charCode >= 65 && charCode <= 90) || // Uppercase letters
      (charCode >= 97 && charCode <= 122) || // Lowercase letters
      charCode === 46 || // Dot
      (charCode === 32 && !currentValue.endsWith(' '))) { // Single space and not after another space
      return true;
    }

    // Block all other characters
    return false;
  }

  textandspecialcharsOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122) && (charCode < 32 || charCode > 47)) {
      return false;
    }
    return true;
  }
  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }
  toggleShowConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
  onPaste(event: ClipboardEvent): void {
    event.preventDefault(); // Prevent the paste action
    alert('Pasting is disabled in the Confirm Password field for security reasons.');
  }


  //passwordMatchValidator(form: FormGroup) {
  //  const password = form.get('password')?.value;
  //  const confpassword = form.get('confpassword')?.value;
  //  return password === confpassword ? null : { mismatch: true };
  //}

  get password() {
    return this.form.get('password');
  }

  get confirmPassword() {
    return this.form.get('confpassword');
  }

  //SendOTP() {
  //  this.isButtonDisabled = true;
  //  var otpdata = {
  //    otpType: 'mobile',
  //    otpValue: this.form.controls.mobnum.value
  //  };
  //  this.ia_serv.sendOTP(otpdata).subscribe(res => {
  //    if (res.status) {
  //      var msg = 'Mobile OTP sent successfully';
  //      alert(msg);
  //    }
  //    else {
  //      var msg = 'Error... Please try after sometime!!';
  //    }
  //  });
  //}
  SendOTP() {
    this.form.controls['MobileNumber'].markAsTouched();
    if (this.form.controls.MobileNumber.invalid) {
      //alert('Please enter a valid mobile number.');
      return;
    }
    //this.isButtonDisabled = true;
    this.isButtonMobileDisabled = true; // Disable "Send Mobile OTP" button
    /*this.isButtonMobileDisabled = true; // Disable the Mobile Resend OTP button*/
    const otpdata =
    {
      otpType: 'mobile',
      otpValue: this.form.controls.MobileNumber.value
    }
    //this.apiService.postRequest(API_ENDPOINTS.Otp.SendOtp, otpdata).subscribe(
    //  res => {
    //    if (res.status) {
    //      this.toastr.success(res.message);
    //      this.mobileOtpSent = true;
    //      this.isVerifyMobileOtpButtonDisabled = false;  // Enable Verify button after OTP sent
    //      this.startMobileOtpTimer();
    //      //this.startMobileOtpTimer();

    //      ////this.startResendCountdown();
    //      //this.isButtonMobileDisabled = true; // Re-enable if there's an error
    //      ////this.isButtonDisabled = true;
    //    }
    //    else {
    //      //alert('Entered Mobile OTP is incorrect. Please enter correct OTP');
    //      //this.isButtonDisabled = false;
    //      this.isButtonMobileDisabled = false; // Re-enable if there's an error
    //    }
    //  });

    // First API call to check if the mobile number exists
    this.apiService.getRequest(API_ENDPOINTS.IA.CHECKMOBILEEXIST, { MobileNumber: this.form.controls.MobileNumber.value }).subscribe(
      res => {
        if (res.status) {
          if (res.message == "Mobile number already exists.") {
            this.toastr.warning(res.message);
            this.isButtonMobileDisabled = false; // Re-enable if number exists
          } else {
            // If the number does not exist, proceed to send OTP
            this.apiService.postRequest(API_ENDPOINTS.Otp.SendOtp, otpdata).subscribe(
              res => {
                if (res.status) {
                  this.toastr.success(res.message);
                  this.mobileOtpSent = true;
                  this.isVerifyMobileOtpButtonDisabled = false; // Enable Verify button after OTP sent
                  this.startMobileOtpTimer();
                } else {
                  alert('Entered Mobile OTP is incorrect. Please enter correct OTP');
                  this.isButtonMobileDisabled = false; // Re-enable if there's an error
                }
              }
            );
          }
        }
      }
    );
  }


  SendSpocOTP() {
    this.form.controls['SpocMobile'].markAsTouched();
    if (this.form.controls.SpocMobile.invalid) {
      //alert('Please enter a valid mobile number.');
      return;
    }
    //this.isButtonDisabled = true;
    //this.isButtonMobileDisabled = true; // Disable "Send Mobile OTP" button
    this.isButtonSpocMobileDisabled = true; // Disable the Mobile Resend OTP button


    this.isSpocOTPVerified = false;
    this.form.controls['spocmobotp'].enable(); // Ensure FormControl is enabled
    const otpdata =
    {
      otpType: 'mobile',
      otpValue: this.form.controls.SpocMobile.value
    }

    this.apiService.postRequest(API_ENDPOINTS.Otp.SendOtp, otpdata).subscribe(
      res => {
        if (res.status) {
          this.toastr.success(res.message);
          this.mobileOtpSent = true;
          this.isVerifySpocMobileOtpButtonDisabled = false;  // Enable Verify button after OTP sent
          this.startSpocMobileOtpTimer();
          //this.startMobileOtpTimer();

          ////this.startResendCountdown();
          //this.isButtonMobileDisabled = true; // Re-enable if there's an error
          ////this.isButtonDisabled = true;
        }
        else {
          //alert('Entered Mobile OTP is incorrect. Please enter correct OTP');
          //this.isButtonDisabled = false;
          this.isButtonSpocMobileDisabled = false; // Re-enable if there's an error
        }
      });
  }

  SendEmailOTP() {
    
    this.form.controls['Email'].markAsTouched();
    if (this.form.controls.Email.invalid) {
      //alert('Please enter a valid email.');
      return;
    }

    //this.isButtonEmailDisabled = true;
    this.isButtonEmailDisabled = true; // Disable "Send Email OTP" button
    const emailotpdata =
    {
      otpType: 'email',
      otpValue: this.form.controls.Email.value
    }
    this.apiService.getRequest(API_ENDPOINTS.IA.CHECKEMAILEXIST, { Email: this.form.controls.Email.value }).subscribe(
    
      res => {
        
        if (res.status) {
          if (res.message == "Email already exists.") {
            this.toastr.warning(res.message);
            this.isButtonEmailDisabled = false;
          }
          else {
            this.apiService.postRequest(API_ENDPOINTS.Otp.SendOtp, emailotpdata).subscribe(
              res => {
                if (res.status) {
                  this.toastr.success(res.message);
                  this.emailOtpSent = true;
                  this.isVerifyEmailOtpButtonDisabled = false; // Enable Verify button after OTP sent
                  this.startEmailOtpTimer();
                  // this.startEmailOtpTimer();
                  //// this.startResendCountdown();
                  // this.isButtonEmailDisabled = true;
                }
                else {
                  alert('Entered  OTP is incorrect. Please enter correct OTP');
                  this.isButtonEmailDisabled = false; // Re-enable if there's an error
                }
              });
          }
          
        } 

        
        
          
        
      });

    
    this.form.controls['Email'].valueChanges.subscribe(() => {
      this.isButtonEmailDisabled = false;
    });

    //this.apiService.postRequest(API_ENDPOINTS.Otp.SendOtp, emailotpdata).subscribe(
    //  res => {
    //    if (res.status) {
    //      this.toastr.success(res.message);
    //      this.emailOtpSent = true;
    //      this.isVerifyEmailOtpButtonDisabled = false; // Enable Verify button after OTP sent
    //      this.startEmailOtpTimer();
    //      // this.startEmailOtpTimer();
    //      //// this.startResendCountdown();
    //      // this.isButtonEmailDisabled = true;
    //    }
    //    else {
    //      alert('Entered  OTP is incorrect. Please enter correct OTP');
    //      this.isButtonEmailDisabled = false; // Re-enable if there's an error
    //    }
    //  });
  }


  ReSendMobileOTP() {
    if (!this.form.controls.MobileNumber.valid) {
      //alert('Please enter a valid mobile number.');
      return;
    }

    if (this.mobileResendCount >= this.maxResendAttempts) {
      this.toastr.warning('You have reached the maximum resend attempts for mobile OTP today.', 'Warning');
      //alert('You have reached the maximum resend attempts for mobile OTP today.');
      return;
    }

    this.mobileResendCount++;
    this.isButtonMobileDisabled = true; // Disable resend button until request complet
    //this.isButtonDisabled = true;

    const otpdata = {
      otpType: 'mobile',
      otpValue: this.form.controls.MobileNumber.value
    };

    this.apiService.postRequest(API_ENDPOINTS.Otp.SendOtp, otpdata).subscribe(res => {
      if (res.status) {
        this.resetCountdown(); // Restart the countdown for mobile OTP
        this.startMobileOtpTimer(); // Start the mobile OTP timer after resend
        //this.isButtonDisabled = false;
      } else {
        alert('Error... Please try after sometime!!');
        this.isButtonMobileDisabled = false; // Re-enable if there's an error
      }
    });
  }

  ReSendSpocMobileOTP() {
    if (!this.form.controls.SpocMobile.valid) {
      //alert('Please enter a valid mobile number.');
      return;
    }

    if (this.mobileResendCount >= this.maxResendAttempts) {
      this.toastr.warning('You have reached the maximum resend attempts for mobile OTP today.', 'Warning');
      //alert('You have reached the maximum resend attempts for mobile OTP today.');
      return;
    }

    this.mobileResendCount++;
    this.isButtonMobileDisabled = true; // Disable resend button until request complet
    //this.isButtonDisabled = true;

    const otpdata = {
      otpType: 'mobile',
      otpValue: this.form.controls.SpocMobile.value
    };

    this.apiService.postRequest(API_ENDPOINTS.Otp.SendOtp, otpdata).subscribe(res => {
      if (res.status) {
        this.resetCountdown(); // Restart the countdown for mobile OTP
        this.startSpocMobileOtpTimer(); // Start the mobile OTP timer after resend
        //this.isButtonDisabled = false;
      } else {
        alert('Error... Please try after sometime!!');
        this.isButtonMobileDisabled = false; // Re-enable if there's an error
      }
    });
  }

  //seperation of function by MP
  ReSendEmailOTP() {
    // Now only check the email validity
    if (!this.form.controls.Email.valid) {
      //alert('Please enter a valid email.');
      this.isButtonDisabled = false;
      return;
    }
    if (this.emailResendCount >= this.maxResendAttempts) {
      this.toastr.warning('You have reached the maximum resend attempts for email OTP today', 'Warning');
      //alert('You have reached the maximum resend attempts for email OTP today.');
      return;
    }

    this.emailResendCount++;  // Increment email resend counter
    this.isButtonEmailDisabled = true; // Disable resend button until request completes

    const emailotpdata = {
      otpType: 'email',
      otpValue: this.form.controls.Email.value
    };

    this.apiService.postRequest(API_ENDPOINTS.Otp.SendOtp, emailotpdata).subscribe(res => {
      if (res.status) {
        this.toastr.success(res.message);
        this.startEmailOtpTimer(); // Restart the email OTP timer
        this.isVerifyEmailOtpButtonDisabled = false; // Enable the Verify button after resend
        this.resetCountdown();
        this.isButtonDisabled = true;
      } else {
        alert('Error... Please try after sometime!!');
        this.isButtonEmailDisabled = true; // Disable resend button until request completes
      }
    });
  }


  

  //seperation of function by MP
  verifyMobileOtp() {
    const otpdata = {
      OtpType: 'mobile',
      OtpValue: this.form.controls.MobileNumber.value,
      Otp: this.form.controls.mobotp.value?.toString()
    };

    this.apiService.postRequest(API_ENDPOINTS.Otp.VerifyOtp, otpdata).subscribe(
      (res) => {
        /*if (res.status)*/
        if (res.message === "OTP verified successfully.") {
          this.toastr.success(res.message);
          this.otpError = false;
          this.otpSuccess = true;
          
          this.stopMobCountdown();
          // Mark the OTP field as readonly
          this.isMobOTPVerified = true;
          this.form.controls.mobotp.disable(); // Disable the field to make it readonly
          this.resendMobileOtpDisabled = true;
          this.isVerifyMobileOtpButtonDisabled = true;//added t odisable the verify button after verification

          //setTimeout(() => {
          //  this.resendMobileOtpDisabled = false;
          //}, 5 * 60 * 1000); // 5 minutes
        } else {
          this.otpError = true;
          this.otpSuccess = false;
        }
      },
      (error) => {
        //console.error('Error during mobile OTP verification:', error);
        //this.toastr.error("Entered Mobile OTP is incorrect. Please enter correct OTP");
        this.otpError = true;
        this.otpSuccess = false;
      }
    );
  }

  verifySpocMobileOtp() {
    const otpdata = {
      OtpType: 'mobile',
      OtpValue: this.form.controls.SpocMobile.value,
      Otp: this.form.controls.spocmobotp.value?.toString()
    };

    this.apiService.postRequest(API_ENDPOINTS.Otp.VerifyOtp, otpdata).subscribe(
      (res) => {
        /*if (res.status)*/
        if (res.message === "OTP verified successfully.") {
          this.toastr.success(res.message);
          this.otpError = false;
          this.otpSuccess = true;
          this.stopCountdown();
          this.stopSpocMobCountdown();
          /*this.mobileSpocOtpTimer = 60;//if verified even after 1 minthe resend otp button will be disabled*/
          // Mark the OTP field as readonly
          this.isOTPVerified = true;
          this.form.controls.spocmobotp.disable(); // Disable the field to make it readonly
          //this.isResendButtonDisabled = true; //if verified even after 1 minute resend otp button will be disabled */
          this.isSpocOTPVerified = true; //for spoc
          this.isVerifySpocMobileOtpButtonDisabled = true;
          this.resendSpocMobileOtpDisabled = true;
        } else {
          this.otpError = true;
          this.otpSuccess = false;
        }
      },
      (error) => {
        //console.error('Error during mobile OTP verification:', error);
        //this.toastr.error("Entered Mobile OTP is incorrect. Please enter correct OTP");
        this.otpError = true;
        this.otpSuccess = false;
      }
    );
  }


  verifyEmailOtp() {
    const emailotpdata = {
      OtpType: 'email',
      OtpValue: this.form.controls.Email.value,
      Otp: this.form.controls.emailotp.value?.toString()
    };

    this.apiService.postRequest(API_ENDPOINTS.Otp.VerifyOtp, emailotpdata).subscribe(
      (res) => {
        /*if (res.status)*/
        if (res.message === "OTP verified successfully.") {
          this.toastr.success(res.message);
          this.emailotpError = false;
          this.emailotpSuccess = true;
          
          this.stopEmailCountdown();

          // Mark the OTP field as readonly
          this.isEmailOTPVerified = true;
          this.form.controls.emailotp.disable(); // Disable the field to make it readonly
          this.resendEmailOtpDisabled = true;
          this.isVerifyEmailOtpButtonDisabled = true;//added t odisable the verify button after verification
        } else {
          this.emailotpError = true;
          this.emailotpSuccess = false;
        }
      },
      (error) => {
        //console.error('Error during email OTP verification:', error);
        //this.toastr.error("Entered Email OTP is incorrect. Please enter correct OTP");
        this.emailotpError = true;
        this.emailotpSuccess = false;
      }
    );
  }




  async LoadFocusSector() {
    try {
      const data = await this.apiService.getRequest(API_ENDPOINTS.FOCUSSECTOR.GETFOCUSSECTOR).toPromise();
      if (Array.isArray(data)) {
        this.focusSector = data;
      } else if (data.data && Array.isArray(data.data)) {
        this.focusSector = data.data;
      } else {
        console.error('Unexpected data structure:', data);
      }
    } catch (error) {
      console.error('Error fetching focus sectors:', error); // Handle error
    }



  };
  async loadInterventions(): Promise<void> {
    try {
      const data = await this.apiService.getRequest(API_ENDPOINTS.MASTERS.INTERVENTION.GETLIST).toPromise();
      if (data.data && Array.isArray(data.data)) {
        this.interventions = data.data;
      } else {
        console.error('Unexpected data structure:', data);
      }
    } catch (error) {
      console.error('Error fetching interventions:', error);
    }
  };
  async loadInterests(): Promise<void> {
    try {
      const data = await this.apiService.getRequest(API_ENDPOINTS.MASTERS.INTEREST.GETLIST).toPromise();
      if (data.data && Array.isArray(data.data)) {
        this.interests = data.data;
      } else {
        console.error('Unexpected data structure:', data);
      }
    } catch (error) {
      console.error('Error fetching interests:', error); // Handle error
    }
  };

  generateCaptcha(): void {
    this.captcha = this.captchaService.generateCaptcha();
    this.drawCaptcha();
  }
  drawCaptcha(): void {
    const canvas: HTMLCanvasElement = document.getElementById('captchaCanvas') as HTMLCanvasElement;
    const context = canvas.getContext('2d');
    if (context) {
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.font = '30px Arial';
      context.fillStyle = '#000';
      context.fillText(this.captcha, 10, 35);
    }
  }

 


  SendtoPreview(form: any) {
    if (this.form.valid && this.spocList.length >= 1 && this.selectedPairs.length >= 1) {
      //const userinput = this.form.controls.captcha.value as string;
      //if (this.captchaService.validateCaptcha(userinput, this.captcha))
      //{
      this.form.controls.focusSectorId.setValue(this.selectedFocusSector?.join(','));
      this.form.controls.focusSectorName.setValue(this.selectedFocusSectorName?.join(','));

      if (this.form.valid) {

        if (form.controls.Password.value != form.controls.confpassword.value) {
          alert("Password and Confirm Password does not match")
          return;
        }

        //this.form.controls.focusSectorId.setValue(this.selectedFocusSector?.join(','));
        //this.form.controls.focusSectorName.setValue(this.selectedFocusSectorName?.join(','));
        if (form.valid) {

          const formdatavalue = {
            ...this.formData,
            ...this.getFormValuesIncludingDisabled(),

            iaUserInterests: this.selectedPairs,
            iaRegistrationSpocDetails: this.spocList,

          };
          //console.log(formdatavalue);
          sessionStorage.setItem('iaRegisterCompleted', 'true');
          this.router.navigate(['/iapreviewpage'], { state: { formData: formdatavalue } });
        } else {
          this.form.markAllAsTouched();
          return;
        }
      }
      else {
        alert("Form not valid");
        return;
      }

      //}
      //else {
      //  this.captchaError = true;
      //  this.generateCaptcha();
      //}
    }
    else {
      this.form.markAllAsTouched();

    }
  }

  //onFocusSectorChange(event: any) {
  //  const focusSectorId = event.target.value;
  //  const focusSectorName = event.target.name;
  //  const isChecked = event.target.checked;

  //  if (isChecked) {
  //    if (!this.selectedFocusSector.includes(focusSectorId)) {
  //      this.selectedFocusSector.push(focusSectorId);
  //      this.selectedFocusSectorName.push(focusSectorName);
  //    }


  //  } else {
  //    const index = this.selectedFocusSector.indexOf(focusSectorId);
  //    if (index > -1) {
  //      this.selectedFocusSector.splice(index, 1);
  //    }
  //  }
  //}

  onFocusSectorChange(event: Event, focusSectorId: string, focusSectorName: string) {
    const inputElement = event.target as HTMLInputElement;
    const isChecked = inputElement.checked;

    if (isChecked) {
      if (!this.selectedFocusSector.includes(focusSectorId)) {
        this.selectedFocusSector.push(focusSectorId);
        this.selectedFocusSectorName.push(focusSectorName);
      }
    } else {
      const index = this.selectedFocusSector.indexOf(focusSectorId);
      if (index > -1) {
        this.selectedFocusSector.splice(index, 1);
        this.selectedFocusSectorName.splice(index, 1);
      }
    }
  }



  onInterventionChange(event: any): void {
    const interventionId = event.interventionId;
    this.filteredInterests = this.interests.filter(interest =>
      interest.interventionId == interventionId
    );
  }

  //addPair(): void {
  //  const interventionId = this.form.get('Intervention')?.value;
  //  const interestId = this.form.get('InterestsId')?.value;

  //  // Check if both fields are selected
  //  if (!interventionId) {
  //    alert('Please select an intervention.');
  //    return;
  //  }

  //  if (!interestId) {
  //    alert('Please select an interest.');
  //    return;
  //  }

  //  if (interventionId && interestId) {
  //    const selectedIntervention = this.interventions.find(type => type.interventionId == interventionId);
  //    const selectedInterest = this.interests.find(type => type.interestId == interestId);

  //    if (selectedIntervention && selectedInterest) {
  //      // Check for duplicates
  //      const duplicate = this.selectedPairs.some(pair =>
  //        pair.interventionId === selectedIntervention.interventionId &&
  //        pair.interestId === selectedInterest.interestId
  //      );

  //      if (!duplicate) {
  //        // Check intervention type for max interest limit
  //        const isCapacityBuilding = selectedIntervention.interventionName === 'Capacity Building';
  //        const maxInterests = isCapacityBuilding ? 3 : Infinity; // Set limit based on intervention type

  //        // Count current interests for the selected intervention
  //        const currentCount = this.selectedPairs.filter(pair => pair.interventionId === selectedIntervention.interventionId).length;

  //        if (isCapacityBuilding && currentCount >= maxInterests) {
  //          alert('You can only add a maximum of 3 interests for Capacity Building.');
  //        } else {
  //          this.selectedPairs.push({
  //            interventionId: selectedIntervention.interventionId,
  //            interventionName: selectedIntervention.interventionName,
  //            interestId: selectedInterest.interestId,
  //            interestName: selectedInterest.interestName,
  //          });
  //          this.resetSelection();
  //        }
  //      } else {
  //        alert('This intervention and interest pair already exists.');
  //      }
  //    }
  //  }
  //}

  addPair(): void {
    const interventionId = this.form.get('Intervention')?.value;
    const interestId = this.form.get('InterestsId')?.value;

    // Check if both fields are selected
    if (!interventionId) {
      alert('Please select an intervention.');
      return;
    }

    if (!interestId) {
      alert('Please select an interest.');
      return;
    }

    if (interventionId && interestId) {
      const selectedIntervention = this.interventions.find(type => type.interventionId == interventionId);
      const selectedInterest = this.interests.find(type => type.interestId == interestId);

      if (selectedIntervention && selectedInterest) {
        // Check for duplicates
        const duplicate = this.selectedPairs.some(pair =>
          pair.interventionId === selectedIntervention.interventionId &&
          pair.interestId === selectedInterest.interestId
        );

        if (!duplicate) {
          this.selectedPairs.push({
            interventionId: selectedIntervention.interventionId,
            interventionName: selectedIntervention.interventionName,
            interestId: selectedInterest.interestId,
            interestName: selectedInterest.interestName,
          });
          this.resetSelection();
        } else {
          alert('This intervention and interest pair already exists.');
        }
      }
    }
  }

  //previous
  // Add function to add form data to the records array
  //add(): void {

  //  if (this.form.controls.SpocName.value && this.form.controls.SpocDesignation.value && this.form.controls.SpocEmail.value && this.form.controls.SpocMobile.value && this.isSpocOTPVerified == true) {
  //    // Add the form values to the records array only if the form is valid

     
  //      this.spocList.push({
  //        SpocName: this.form.controls.SpocName.value,
  //        SpocDesignation: this.form.controls.SpocDesignation.value,
  //        SpocEmail: this.form.controls.SpocEmail.value,
  //        SpocMobile: this.form.controls.SpocMobile.value

  //      });
  //      this.editingIndex = null;
  //      //this.form.reset();
  //    this.form.get('spocmobotp')?.reset(); // Clear the SpocMobile field

  //    this.isButtonSpocMobileDisabled = false;
  //    this.mobileSpocOtpTimerRunning = false;
      


  //    // Reset the form after adding the record
  //    this.resetSpocSelection();
  //    this.form.controls['spocmobotp'].enable(); 

  //  }
  //  else {
  //    this.toastr.error("Fill in the Spoc deatils and verify the OTP to add.");
  //  }
  //  this.isSpocOTPVerified = false;
  //  this.form.get('spocmobotp')?.reset();
    


  //  //this.form.controls.spocmobotp.markAllAsTouched
    
  //  //this.form.controls.spocmobotp.markAsTouched();
  //  return;

  //}

  add(): void {
    if (
      this.form.controls.SpocName.value &&
      this.form.controls.SpocDesignation.value &&
      this.form.controls.SpocEmail.value &&
      this.form.controls.SpocMobile.value &&
      this.isSpocOTPVerified
    ) {
      const newData = {
        SpocName: this.form.controls.SpocName.value,
        SpocDesignation: this.form.controls.SpocDesignation.value,
        SpocEmail: this.form.controls.SpocEmail.value,
        SpocMobile: this.form.controls.SpocMobile.value
      };

      if (this.editingIndex !== null) {
        // Check if data has changed
        if (JSON.stringify(this.originalData) !== JSON.stringify(newData)) {
          // Update existing record
          this.spocList.splice(this.editingIndex, 0, newData);
        } else {
          // Re-add the original record without change
          this.spocList.splice(this.editingIndex, 0, this.originalData);
        }
        this.editingIndex = null;
      } else {
        // Add new record normally
        this.spocList.push(newData);
      }

      //  Reset form fields after updating
      this.resetSpocSelection();

      this.isButtonSpocMobileDisabled = false;
      this.mobileSpocOtpTimerRunning = false;
      this.form.controls['spocmobotp'].enable();
    } else {
      this.toastr.error("Fill in the Spoc details and verify the OTP to add.");
    }

    this.isSpocOTPVerified = false;
    this.form.get('spocmobotp')?.reset();
    this.form.controls.spocmobotp.markAllAsTouched();
  }

  //previous
  //resetSpocSelection(): void {
  //  if (this.txtResetCancel == 'Cancel') {
  //    // const data =  this.holdEditData;
  //    if (this.holdEditData != null || this.holdEditData != undefined) {
  //      this.spocList.push({
  //        SpocName: this.holdEditData?.SpocName,
  //        SpocDesignation: this.holdEditData?.SpocDesignation,
  //        SpocEmail: this.holdEditData?.SpocEmail,
  //        SpocMobile: this.holdEditData?.SpocMobile
  //      });
  //      this.holdEditData = null;
  //      this.txtResetCancel = 'Reset'
  //      this.form.get('SpocName')?.reset();
  //      this.form.get('SpocDesignation')?.reset();
  //      this.form.get('SpocEmail')?.reset();
  //      this.form.get('SpocMobile')?.reset();
  //    }
      

  //  } else {
  //  this.form.get('SpocName')?.reset();
  //  this.form.get('SpocDesignation')?.reset();
  //  this.form.get('SpocEmail')?.reset();
  //  this.form.get('SpocMobile')?.reset();
  //  }
    

  //  this.filteredInterests = [];
  //}

  resetSpocSelection(): void {
   
    if (this.txtResetCancel === 'Cancel') {
      //  Check if user made any changes
      const currentData = {
        SpocName: this.form.controls.SpocName.value,
        SpocDesignation: this.form.controls.SpocDesignation.value,
        SpocEmail: this.form.controls.SpocEmail.value,
        SpocMobile: this.form.controls.SpocMobile.value,
      };

      if (JSON.stringify(currentData) === JSON.stringify(this.originalData)) {
        // No changes were made, restore original data back to the table
        this.spocList.push(this.originalData);
      }

      this.holdEditData = null;
      this.originalData = null;
      this.txtResetCancel = 'Reset';
    }

    //  Reset only the Spoc fields
    this.form.patchValue({
      SpocName: '',
      SpocDesignation: '',
      SpocEmail: '',
      SpocMobile: '',
      spocmobotp: ''
    });
    this.stopSpocMobCountdown();
    //this.isButtonMobileDisabled = false;
    //this.isButtonSpocMobileDisabled = false;
    this.resendSpocMobileOtpDisabled = true;
    this.isButtonSpocMobileDisabled = false;

    this.editingIndex = null;
  }


  resetSelection(): void {
    this.form.get('Intervention')?.setValue('');
    this.form.get('InterestsId')?.setValue('');
    this.filteredInterests = [];
  }

  removePair(index: number): void {
    this.selectedPairs.splice(index, 1);
  }
  removeSpoc(index: number): void {
    // Confirm removal
    if (confirm("Are you sure you want to remove this SPOC?")) {
      // Remove the SPOC from the spocList array at the specified index
      this.spocList.splice(index, 1);
    }
  }

  //previous
  //editSpoc(index: number) {
  //  //this.editingIndex = index; // Save the index of the record being edited
  //  //const selectedSpoc = this.spocList[index];
  //  //this.form.patchValue(selectedSpoc); // Populate form with the selected record's data
  //  //this.spocList.splice(index, 1);

  // // this.isButtonMobileDisabled = false;
  //  /*this.isSpocOTPVerified = true;*/

  //  this.txtResetCancel = 'Cancel'

  //  this.isButtonSpocMobileDisabled = false;
  //  this.mobileSpocOtpTimerRunning = false;
  //  this.mobileSpocOtpTimer = 300;
  //  // Enable the button


  //  this.editingIndex = index;
  //  const spoc = this.spocList[index];
    
  //  this.holdEditData = spoc;

  //  this.form.patchValue(spoc);

  //  this.form.get('spocmobotp')?.reset(); // Clear the SpocMobile field


  //  this.spocList.splice(index, 1);
  //}

  editSpoc(index: number): void {
    //debugger;
    this.txtResetCancel = 'Cancel';

    this.isButtonSpocMobileDisabled = false;
    this.mobileSpocOtpTimerRunning = false;
    this.mobileSpocOtpTimer = 300;

    this.editingIndex = index;
    const spoc = this.spocList[index];

    // Store original record for comparison
    this.holdEditData = { ...spoc };
    this.originalData = { ...spoc }; //  Store this for change detection

    this.form.patchValue(spoc);

    // Mark the record as edited
    spoc.isEdited = true;

    this.form.get('spocmobotp')?.reset();
    this.spocList.splice(index, 1);
  }
  

  getFormValuesIncludingDisabled() {
    const formValues = this.form.getRawValue();
    return formValues;
  }

  // Prevent entering space at the start
  preventStartingSpace(event: KeyboardEvent): void {
    const inputElement = event.target as HTMLInputElement;
    // Prevent starting space
    // Prevent leading space
    if (inputElement.selectionStart === 0 && event.key === ' ') {
      event.preventDefault();
    }

    // Remove trailing spaces immediately on "Enter" or "Tab"
    if (event.key === 'Enter' || event.key === 'Tab') {
      inputElement.value = inputElement.value.trim();
    }
  }

  // Additional function to handle trailing spaces on blur
  removeTrailingSpacesOnBlur(inputElement: HTMLInputElement): void {
    inputElement.value = inputElement.value.trim();
  }

  onReset() {
    if (confirm("Are you sure you want to reset the form?")) {

      // Clear history state formData
      history.replaceState({}, '', window.location.pathname);

      //this.form.reset();
      this.selectedPairs = [];
      this.spocList = [];

      sessionStorage.clear();
      this.form.reset();//added to reset the form
      this.stopMobCountdown();//to stop timer
      this.stopEmailCountdown();// to stop timer

      this.stopSpocMobCountdown();
      this.form.controls.mobotp.enable();
      this.form.controls.emailotp.enable();
      this.form.controls.spocmobotp.enable();

      //this.SendEmailOTP();
      //this.SendOTP();
      //this.SendSpocOTP()

      this.isButtonEmailDisabled = false;//email send otp button enabled
      this.resendEmailOtpDisabled = true;// email,resend otp button disabled

      this.isButtonMobileDisabled = false;//mobile send otp button enabled
      this.resendMobileOtpDisabled = true;//mobile resend otp button disabled

      this.resendSpocMobileOtpDisabled = true;
      
    }
  }

}

//export function passwordMatchValidator(group: AbstractControl): ValidationErrors | null {
//  const password = group.get('Password')?.value;
//  const confirmPassword = group.get('confpassword')?.value;

//  return password && confirmPassword && password !== confirmPassword
//    ? { passwordMismatch: true }
//    : null;
//}

